import { render, staticRenderFns } from "./WidgetPrimaryOffers.vue?vue&type=template&id=a59915cc&"
import script from "./WidgetPrimaryOffers.vue?vue&type=script&lang=ts&"
export * from "./WidgetPrimaryOffers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/dashboard/widgets/_locales/WidgetPrimaryOffers.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fdashboard%2Fwidgets%2FWidgetPrimaryOffers.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports